import { useEffect, useState } from "react";
import api from "../../lib/api";
import { fmtDate } from "../../lib/status";
import { toast } from "sonner";

export default function AdminPGBooks() {
    const [logs, setLogs] = useState([]);
    const [busy, setBusy] = useState(false);
    const [filter, setFilter] = useState("");

    const load = async () => {
        const params = {};
        if (filter) params.status = filter;
        const { data } = await api.get("/pgbooks/sync-logs", { params });
        setLogs(data);
    };
    useEffect(() => {
        load();
    }, [filter]);

    const process = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/pgbooks/process-queue");
            toast.success(
                `Processed ${data.processed} of ${data.total_pending} pending`,
            );
            load();
        } catch (e) {
            toast.error("Failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex items-end justify-between flex-wrap gap-4">
                <div>
                    <div className="lx-label text-[#D4AF37] mb-2">Accounting Integration</div>
                    <h1 className="font-serif text-4xl text-white">PG Books sync</h1>
                    <p className="text-sm text-white/60 mt-2 max-w-2xl">
                        All invoices, payouts and refunds are queued here and pushed to
                        the external PG Books system. Mock endpoint enabled for MVP.
                    </p>
                </div>
                <div className="flex gap-2">
                    <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        className="bg-[#1C0E24] border border-[#2B1438] text-white px-3 py-2.5 text-sm"
                    >
                        <option value="">All</option>
                        <option value="pending">Pending</option>
                        <option value="success">Success</option>
                        <option value="retry">Retry</option>
                        <option value="failed">Failed</option>
                    </select>
                    <button
                        onClick={process}
                        disabled={busy}
                        data-testid="pgbooks-process-btn"
                        className="lx-btn-gold px-5 py-2.5 disabled:opacity-50"
                    >
                        {busy ? "Processing…" : "Process Queue"}
                    </button>
                </div>
            </div>
            <div className="lx-card-dark overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="border-b border-[#2B1438] text-white/60 text-left">
                        <tr>
                            <th className="p-4 lx-label">Entity</th>
                            <th className="p-4 lx-label">Entity ID</th>
                            <th className="p-4 lx-label">Status</th>
                            <th className="p-4 lx-label">Attempts</th>
                            <th className="p-4 lx-label">PG Ref</th>
                            <th className="p-4 lx-label">Created</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.map((l) => (
                            <tr key={l.id} className="border-b border-[#2B1438]">
                                <td className="p-4 text-white capitalize">{l.entity_type}</td>
                                <td className="p-4 text-white/60 text-xs">
                                    {l.entity_id.slice(0, 8)}…
                                </td>
                                <td className="p-4">
                                    <span
                                        className="text-[10px] uppercase tracking-wider px-2 py-1 border"
                                        style={{
                                            color:
                                                l.status === "success"
                                                    ? "#34C759"
                                                    : l.status === "pending"
                                                      ? "#FF9500"
                                                      : "#FF2D55",
                                            borderColor: "transparent",
                                        }}
                                    >
                                        {l.status}
                                    </span>
                                </td>
                                <td className="p-4 text-white/80">{l.attempts}</td>
                                <td className="p-4 text-[#D4AF37] text-xs">
                                    {l.pg_books_ref || "—"}
                                </td>
                                <td className="p-4 text-white/60 text-xs">
                                    {fmtDate(l.created_at)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {logs.length === 0 && (
                    <div className="p-12 text-center text-white/60">
                        No sync logs yet. Complete a booking to generate one.
                    </div>
                )}
            </div>
        </div>
    );
}
